import { useRef, useState } from "react";
import ContactTile from "./contactTile";

export default function ContactList({ branch, contacts, onGeo }) {
    const height = useRef(null);
    const [divHeight, setHeight] = useState('auto');

    const isOpen = divHeight === 'auto' || divHeight > 0;

    function showData() {
        if (onGeo && branch) onGeo(branch);
        setHeight(isOpen ? 0 : height.current.scrollHeight);
    }

    return (
        <div className={"contact-list border-b border-gray-100 dark:border-white/5 last:border-0"}>

            <div onClick={showData} className="contact-list-name flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                <div className={"text-18 font-bold text-t1"}>{branch.content}</div>

                <img className={"filter-black w-6 h-6 transition-transform duration-300 " + (isOpen ? "rotate-180" : "")}
                    src={"/assets/icons/arrow.svg"} alt={"toggle"} />
            </div>
            <div ref={height} className={"contact-list-info transition-all duration-300 overflow-hidden"} style={{ height: divHeight === 'auto' ? 'auto' : `${divHeight}px` }}>
                <div className="p-4 space-y-4 bg-gray-50/50 dark:bg-white/5">

                    {
                        contacts?.map((contact, index) => {
                            return (
                                <ContactTile
                                    key={index}
                                    icon={contact?.typeIconPath}
                                    value={contact?.contactValue}
                                    type={contact?.typeValue}
                                    name={contact?.contactTitle ?? contact.typeTitle}
                                />
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}